import { render, staticRenderFns } from "./QueryClaimant.vue?vue&type=template&id=04acdd9b&"
import script from "./QueryClaimant.vue?vue&type=script&lang=js&"
export * from "./QueryClaimant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports